/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_3Inputs */

const en_sch_level_3 = /** @type {(inputs: Sch_Level_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiative`)
};

const de_sch_level_3 = /** @type {(inputs: Sch_Level_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiative`)
};

/**
* | output |
* | --- |
* | "Initiative" |
*
* @param {Sch_Level_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_3 = /** @type {((inputs?: Sch_Level_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_3(inputs)
	return en_sch_level_3(inputs)
});